import type { ReactNode } from "react";

type Props = {
  side: "left" | "right";
  label: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function EditorCollapsibleSidebar({
  side,
  label,
  open,
  onToggle,
  children,
}: Props) {
  const collapseIcon = side === "left" ? "‹" : "›";
  const expandIcon = side === "left" ? "›" : "‹";

  return (
    <aside
      className={`editor-sidebar editor-sidebar--${side}${open ? "" : " editor-sidebar--collapsed"}`}
      aria-label={label}
    >
      <div className="editor-sidebar-chrome">
        <button
          type="button"
          className="editor-sidebar-toggle surf-btn surf-btn--ghost"
          onClick={onToggle}
          aria-expanded={open}
          aria-label={open ? `Riduci ${label}` : `Espandi ${label}`}
          title={open ? `Riduci ${label}` : `Espandi ${label}`}
        >
          {open ? collapseIcon : expandIcon}
        </button>
        {open && <span className="editor-sidebar-title">{label}</span>}
      </div>
      {open ? (
        <div className="editor-sidebar-body">{children}</div>
      ) : (
        <button
          type="button"
          className="editor-sidebar-rail"
          onClick={onToggle}
          aria-label={`Espandi ${label}`}
          title={`Espandi ${label}`}
        >
          <span className="editor-sidebar-rail-label">{label}</span>
        </button>
      )}
    </aside>
  );
}
